import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { browserHistory } from 'react-router';

import {
  TimeHelpers,
  restaurantById,
  availableSpotsSelector,
  // bookingRushResturantsSelector,
  // rushSlotsForRestaurantSelector,
  // rushSlotsMapSelector,
  pickerTimeSelector,
  formDataSelector,
  // pickerSelectedSeatsIsPlus,
} from '@arreeba/ristoranti-frontend-lib';

import { urlSelector } from '../../selectors/urlSelectors';
import BookingForm from './booking-form';
import Button from '../../components/button';
import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';
import NumberPicker from '../../components/number-picker';
import { connect } from '../../util';
import Url from '../../lib/url';
import { COMMON_LOCALIZED } from '../../lib/localized';


const TimeRow = ({ data, selected, onClick }) => {
  const isSelected = selected === data.value;
  return (
    <li
      onClick={() => !isSelected && onClick(data)}
      className={classNames({ selected: isSelected })}
    >
      {data.label}
    </li>
  );
};
TimeRow.propTypes = {
  selected: PropTypes.string,
  data: PropTypes.shape({
    label: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

const BookingTimeSeats = props => {
  const { booking, actions, ux, url } = props;

  if (ux.bookingFormVisible) {
    return React.createElement(BookingForm, props);
  }

  const targetRestaurant = props.routeParams.restaurantId;
  const restaurant = restaurantById(props.app.merchant.restaurants, targetRestaurant);

  const onTimeSelected = data => actions.booking.setBookingTime(data.value, false);
  const updateSeats = n => actions.booking.setBookingSeats(n);

  const onConfirm = () => {
    const checkoutUrl = Url.bookingCheckout(
      url.appId,
      url.restaurantId,
      url.bookingDate,
      booking.time,
      booking.seats,
    );
    browserHistory.push(checkoutUrl);
  };

  const locale = 'it';
  const day = TimeHelpers.weekDayLocale(booking.date.date, locale);
  const date = TimeHelpers.toLocalDate(booking.date.date, locale);

  return (
    <main>
      <p className="booking-info">
        Prenotazione per <strong>{day} {date}</strong>.<br />
        <strong>{restaurant.name}</strong> – {restaurant.address}.
      </p>

      <p>Seleziona orario e numero di posti</p>
      <div className="grow split-pane full">
        <div className="pane">
          <h4>Orario</h4>
          <p>Seleziona un orario</p>
          <ul className="box-list">
            {props.pickerTime.map(o => (
              <TimeRow data={o} onClick={onTimeSelected} selected={booking.time} key={o.value} />
            ))}
          </ul>
        </div>
        <div className={classNames('pane', { disabled: !booking.time })}>
          <h4>Numero posti {props.availableSpots && (booking.seats === props.availableSpots) && <span className="error">(max posti raggiunti)</span>}</h4>
          <p>Seleziona numero di posti</p>
          <NumberPicker
            max={props.availableSpots}
            current={booking.seats || 0}
            update={updateSeats}
          />
        </div>
      </div>

      <ButtonsContainer>
        <BackButton />
        <span className={classNames({ disabled: !booking.seats })}>
          <Button type="submit" onClick={onConfirm} />
        </span>
      </ButtonsContainer>
    </main>
  );
};


const connectOptions = {
  mapStateToProps: (state, props) => ({
    ...state,
    url: urlSelector(state, props),
    availableSpots: availableSpotsSelector(state, props),
    pickerTime: pickerTimeSelector(COMMON_LOCALIZED)(state, props),
    formData: formDataSelector(state),
  }),
};


export default connect(BookingTimeSeats, connectOptions);



// WEBPACK FOOTER //
// ./src/containers/booking/booking-time-seats.js